<template>
  <SysDataTableExpand
    ref="sysDataTablePedidosPendentesRef"
    :height="alturaDaJanela - 415"
    :item-height="45"
    :headers="CABECALHOS_COMPUTED"
    :itemClass="cssLinha"
    :callbacks="CALLBACK_COMPUTED"
    @click:row="exportarDadosLinha"
    @callback-resetar-grid="fn => callbackResetarDadosGrid = fn"
    @click:th="() => abrir_dialog_ordenacao_count++"
  >
    <template #top>
      <Ordenacao
        :id_unico_preferencia="filtros.id_unico_preferencia"
        :itens="colunas_ordenacao"
        :abrir_dialog_ordenacao_count="abrir_dialog_ordenacao_count"
        @update:ordenacao="callbackResetarDadosGrid()"
        @campos:ordenacao="atualizarCamposOrdenados"
      />
    </template>

    <template v-for="(item, key) in campos_em_ordenacao" #[`header.${item.campo}.icon_order`]>
      <span :key="key">
        <v-icon v-if="item.ordem === 'DECRESCENTE'" small v-text="'mdi-arrow-down'" />
        <v-icon v-else small v-text="'mdi-arrow-up'" />
      </span>
    </template>

    <template #_item.descricao_analise="{item}">
      <div class="d-flex align-center" style="width: 290px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
        <DetalhesProduto
          v-if="item.idproduto && !item.produto_combinado"
          :produto="{
            id_grupo: item.id_grupo,
            id_filial: item.filial,
            id_fornecedor: item.id_fornecedor,
            id_produto: item.idproduto, 
            incluir_produtos_fora_linha: true
          }"
        />
        <span v-text="item.descricao_analise" class="text-truncate" :title="item.descricao_analise" />
      </div>
    </template>

    <template #item.preco_compra="{ item }">
      <FormatarMoeda v-if="item.idproduto" :tipo="item.moeda" />
      <span class="ml-1" v-if="item.idproduto" v-text="item.preco_compra" />
      <span v-else v-text="'-'" />
    </template>

    <template #item.total_pendente="{ item }">
      <FormatarMoeda :tipo="item.moeda" />
      <span class="ml-1" v-text="item.total_pendente" />
    </template>

    <template #item.total_faturado="{ item }">
      <FormatarMoeda :tipo="item.moeda" />
      <span class="ml-1" v-text="item.total_faturado" />
    </template>

    <template #item.total_compra="{ item }">
      <FormatarMoeda :tipo="item.moeda" />
      <span class="ml-1" v-text="item.total_compra" />
    </template>
  </SysDataTableExpand>
</template>

<script>
import SysDataTableExpand from '@/components/utils/dataTable/sysDataTableExpand/Index'
import ResponsiveHeight from '@/helpers/ResponsiveHeight.js';
import { headers } from './Cabecalhos.js';
import { formatarValor, formatarValorComCasas } from "@/helpers";
import * as requisicoes from './Api.js';
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";
import Ordenacao from "@/components/utils/dataTable/Ordenacao.vue";
import { colunas_ordenacao } from './Cabecalhos.js';
import FormatarMoeda from "@/components/utils/FormatarMoeda.vue"; 

export default {
  name: "Tabela",
  components: {
    SysDataTableExpand,
    DetalhesProduto,
    Ordenacao,
    FormatarMoeda
  },
  mixins: [ResponsiveHeight],
  data: () => ({
    campos_em_ordenacao: [],
    colunas_ordenacao: colunas_ordenacao,
    abrir_dialog_ordenacao_count: 0,
    callbackResetarDadosGrid: null,
    interval: null,
    existe_marca: false
  }),
  props: {
    filtros: {
      type: Object,
      required: true
    }
  },
  created() {
    this.verificarExistenciaDeMarca();
  },
  computed: {
    CABECALHOS_COMPUTED() {
      return headers;
    },
    GRUPO_COMPRA() {
      return this.$store.getters['usuario/getGrupoCompras'];
    },
    CALLBACK_COMPUTED() {
      let callbacks = [
        this.buscarFornecedor,
        this.buscarPedidosFornecedor,
        this.buscarProdutosPedidosFornecedor
      ];
      
      if (this.existe_marca) {
        callbacks.unshift(this.buscarMarca);
      }

      return callbacks;
    }
  },
  watch: {
    GRUPO_COMPRA(novo, antigo) {
      if (parseInt(novo) === parseInt(antigo)) return;
      this.callbackResetarDadosGrid();
    },
    'filtros.count_atualizar'() {
      this.callbackResetarDadosGrid();
    },
    'filtros.pesquisar'() {
      clearTimeout(this.interval);
      this.interval = setTimeout(() => this.callbackResetarDadosGrid(), 1000);
    }
  },
  methods: {
    atualizarCamposOrdenados(campos) {
      this.campos_em_ordenacao = campos;
      this.$forceUpdate();
    },
    async verificarExistenciaDeMarca() {
      const response = await requisicoes.verificarExistenciaDeMarca();
      this.existe_marca = response.status;
    },
    async buscarMarca() {
      const linhas = await requisicoes.buscarMarca({... this.filtros, grupos: [this.$store.getters['usuario/getGrupoCompras']]});
      return this.formatarLinhas(linhas);
    },
    async buscarFornecedor(linha) {
      const linhas = await requisicoes.buscarFornecedor({... this.filtros, grupos: [this.$store.getters['usuario/getGrupoCompras']], id_marca: (this.existe_marca ? linha.id_marca : null) });
      return this.formatarLinhas(linhas);
    },
    async buscarPedidosFornecedor(linha) {
      const parametros = {
        ...this.filtros,
        grupos: [this.$store.getters['usuario/getGrupoCompras']],
        id_fornecedor: linha.id_fornecedor, 
        id_marca: (this.existe_marca ? linha.id_marca : null)
      }
      const linhas = await requisicoes.buscarPedidosFornecedor(parametros);
      return this.formatarLinhas(linhas);
    },
    async buscarProdutosPedidosFornecedor(linha) {
      const parametros = {
        ...this.filtros,
        id_grupo: linha.id_grupo,
        id_fornecedor: linha.id_fornecedor,
        id_solicitacao: linha.id_solicitacao, 
        id_marca: (this.existe_marca ? linha.id_marca : null)
      }
      const linhas = await requisicoes.buscarProdutosPedidosFornecedor(parametros);
      return this.formatarLinhas(linhas);
    },
    exportarDadosLinha({ row }) {
      if (this.linha_clicada === row) {
        this.$emit('duplo-click:linha', {...row});
      }

      this.linha_clicada = row;
      setTimeout(() => this.linha_clicada = null, 500);
    },
    formatarLinhas(linhas) {
      const callback = linha => {
        linha.preco_compra = formatarValorComCasas(linha.preco_compra, 2);

        linha.qtde_pendente = formatarValor(linha.qtde_pendente);
        linha.qtde_faturada = formatarValor(linha.qtde_faturada);
        linha.qtde_compra = formatarValor(linha.qtde);

        linha.total_pendente = formatarValorComCasas(linha.total_pendente, 2);
        linha.total_faturado = formatarValorComCasas(linha.total_faturado, 2);
        linha.total_compra = formatarValorComCasas(linha.total_compra, 2);

        linha.dias_em_aberto = `${formatarValor(linha.dias_em_aberto)} dias`;

        return linha;
      }

      return linhas.map(callback);
    },
    cssLinha(linha) {
      return {
        'font-weight-bold': linha.totalizador,
        'cursor-pointer': true
      }
    }
  }
}
</script>
